module.exports = __webpack_public_path__ + "static/media/beko.6cb008af.svg";